var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIconArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2921 23.8017C16.7191 23.8017 8.01339 37.5998 8.00586 52.0875V53.8907C14.2626 46.3535 24.7515 41.7602 33.2921 41.7602V51.2684C33.2924 52.6479 34.081 53.906 35.3225 54.5076C36.564 55.1093 38.0401 54.9486 39.1231 54.094L59.4521 35.505C60.288 34.8462 60.7757 33.8408 60.7757 32.7766C60.7757 31.7124 60.288 30.7069 59.4521 30.0482L39.1231 11.4591C38.0401 10.6045 36.564 10.4439 35.3225 11.0455C34.081 11.6471 33.2924 12.9052 33.2921 14.2848V23.8017Z",
    stroke: "#FAFAFA",
    strokeWidth: 5.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIconArrow);
export default __webpack_public_path__ + "static/media/shareIconArrow.8038d0d82e58886787babf2ed80c2a16.svg";
export { ForwardRef as ReactComponent };